import Header from './components/Header.js';
import Carousel from './components/Carousel.js';
import Video from './components/Video.js';
import Scroller from './components/Scroller.js';
import Scrolly from './components/Scrolly.js';
import Translate from './components/Translate.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Header,
      Carousel,
      Video,
      Scroller,
      Scrolly,
      Translate,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
